import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular/main';
import { DataRevisionIndicator } from '../../shared/data-revision/data-revision-indicator';
import { ICellRendererParams } from 'ag-grid-community';
import { isEmpty } from 'lodash';
import { SubjectColumnParams } from './osr-subject-columns-renderer.component';
import { StandardTestResultsGridColumn } from './standard-test-results.component';

@Component({
    selector: 'standard-test-results-ag-group-renderer',
    template: require('./standard-test-results-ag-group-renderer.component.html'),
    styles: [require('./standard-test-results-ag-group-renderer.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StandardTestResultsAgGroupRendererComponent implements AgRendererComponent {
    public groupType: string;
    public groupValue: string;
    public childrenCounter: number;
    public hasDataRevision = false;
    public params: SubjectColumnParams;
    public revisionMessage: string;

    constructor(private dataRevisionIndicator: DataRevisionIndicator) {
    }

    public refresh() {
        return false;
    }

    public get hasData() {
        return !!this.params;
    }

    public get routerLinkExists() {
        return !isEmpty(this.params.routerLink);
    }

    public agInit(params: ICellRendererParams): void {
        this.params = params.value;

        const groupColumn = params.api.getColumnDef(params.node.field) as StandardTestResultsGridColumn;
        if (groupColumn) {
            this.groupType = groupColumn.headerName;

            if (groupColumn.hasDataRevision && groupColumn.getDataRevisionMessage) {
                this.hasDataRevision = params.node.childrenAfterFilter.some(child => child.data && groupColumn.hasDataRevision(child.data));
                this.revisionMessage = groupColumn.getDataRevisionMessage(this.dataRevisionIndicator);
            }
        }

        this.childrenCounter = params.node.childrenAfterFilter.length;
        this.groupValue = params.node.key ? params.node.key.toString() : null;
    }
}